import { IAddress } from 'main/gql/address'

export function formatAddress(address: IAddress, fuzzy: boolean = false) {
  const region = [address.state, address.postalCode].filter(x => x).join(' ')
  const street = fuzzy ? [] : [address.line1, address.line2]
  return [...street, address.city, region].filter(x => x).join(', ')
}
